import { render, staticRenderFns } from "./dg-cascader.vue?vue&type=template&id=4160c879&scoped=true"
import script from "./dg-cascader.vue?vue&type=script&lang=js"
export * from "./dg-cascader.vue?vue&type=script&lang=js"
import style0 from "./dg-cascader.vue?vue&type=style&index=0&id=4160c879&prod&lang=less&scoped=true"
import style1 from "./dg-cascader.vue?vue&type=style&index=1&id=4160c879&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4160c879",
  null
  
)

export default component.exports